module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/bass-e08dc427cfcc5bdcdbe88e8a0f579b69.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/bass.svg
// module id = ZetO
// module chunks = 24